export const DEFAULT_CORRECTION_X = 0;
export const CORRECTION_X_FOR_LONG_LABELS = 8;
export const CRITICAL_LABEL_LENGTH = 5;
export const CORRECTION_Y = 10;
